"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContactByType = void 0;
const getContactByType = (allowedContacts, contacts, type) => allowedContacts?.includes(type) ? contacts?.filter(contact => contact?.type === type)[0]?.value : null;
exports.getContactByType = getContactByType;
